export default "__VITE_ASSET__09a26761__"